"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shades = void 0;
var _fetching = require("@ori/fetching");
var _labels = require("./labels");
/* istanbul ignore file @preserve */

const shades = exports.shades = (0, _fetching.gql)`
  ${_labels.labels}
  fragment ShadePickerShade on Product {
    backInStockAvailability {
      showBackInStockNotification
    }
    shadeName
    hexColors
    colorImageUrl
    productCode
    formattedPrice {
      price {
        basicCataloguePrice
        currentPrice
        priceAfterImmediateDiscount
      }
    }
    labels {
      ...ProductLabels
    }
  }
`;
